import React from 'react'

import { PageLayout } from '@components/common/PageLayout'
import { Skeleton } from '@fourthwall/components'

export const PodcastSkeleton = () => (
  <PageLayout size="tiny">
    <Skeleton gap={16}>
      <Skeleton.Shape width={280} height={24} />
      <Skeleton.Shape width="100%" height={120} />
      <Skeleton.Shape width="100%" height={152} />
      <Skeleton.Shape width="100%" height={400} />
    </Skeleton>
  </PageLayout>
)
